// Technical Support page Indonesian translations

export default {
  pageTitle: "Dukungan Teknis",
  breadcrumbHome: "Beranda",
  breadcrumbServices: "Layanan",
  breadcrumbCurrent: "Dukungan Teknis",
  
  // Service links
  customManufacturing: "Manufaktur Kustom",
  technicalSupport: "Dukungan Teknis",
  afterSalesService: "Layanan Purnajual",
  qualityAssurance: "Jaminan Kualitas",
  researchDevelopment: "Penelitian & Pengembangan",
  globalSupplyChain: "Rantai Pasokan Global",
  
  // Main content
  title: "Layanan Dukungan Teknis Ahli",
  description1: "Tim dukungan teknis kami di PT Eagle Industry Indonesia menyediakan bantuan komprehensif untuk memastikan kinerja optimal produk kami sepanjang siklus hidupnya. Dengan keahlian mendalam dalam segel mekanis dan komponen presisi, spesialis kami berkomitmen untuk mengatasi tantangan teknis dan memaksimalkan keandalan peralatan untuk pelanggan kami.",
  description2: "Kami memahami bahwa operasi kritis memerlukan solusi teknis yang cepat dan efektif. Tim dukungan kami menggabungkan pengetahuan teoretis dengan pengalaman lapangan praktis untuk memberikan bantuan segera yang meminimalkan waktu henti dan memperpanjang umur layanan peralatan.",
  
  // Services section
  servicesTitle: "Layanan Dukungan Teknis Kami Meliputi:",
  services: [
    "Bantuan teknis darurat 24/7 untuk aplikasi kritis",
    "Pemecahan masalah dan diagnosis masalah di lokasi",
    "Panduan dan supervisi instalasi",
    "Rekomendasi optimasi kinerja",
    "Analisis kegagalan dan identifikasi penyebab akar",
    "Pelatihan teknis untuk tim pemeliharaan pelanggan",
    "Layanan pemantauan dan diagnosis jarak jauh"
  ],
  
  // Specialized support section
  specializedTitle: "Area Dukungan Khusus:",
  specializedDescription: "Dukungan teknis kami mencakup semua kategori produk termasuk segel mekanis, segel tabung buritan, segel apung, segel bibir, dan katup khusus. Kami memiliki spesialis yang didedikasikan untuk berbagai aplikasi industri, memastikan bahwa Anda menerima dukungan dari profesional yang memahami lingkungan operasional dan tantangan spesifik Anda.",
  
  // Metrics
  responseTime: "Waktu Respon",
  responseTimeDesc: "Respon cepat dengan ketersediaan 24/7 untuk masalah kritis",
  technicalExpertise: "Keahlian Teknis",
  technicalExpertiseDesc: "Spesialis dengan pengetahuan industri yang luas",
  problemResolution: "Resolusi Masalah",
  problemResolutionDesc: "Pendekatan sistematis untuk mengidentifikasi dan mengatasi penyebab akar",
  globalSupport: "Dukungan Global",
  globalSupportDesc: "Bantuan teknis yang konsisten di semua wilayah operasi",
  
  // Process section
  processTitle: "Proses Dukungan Kami:",
  processDescription: "Ketika Anda menghubungi tim dukungan teknis kami, kami mengikuti pendekatan terstruktur untuk memastikan resolusi masalah yang efisien. Ini termasuk penilaian awal, diagnosis jarak jauh jika memungkinkan, dukungan di lokasi untuk masalah kompleks, dan tindak lanjut untuk memverifikasi efektivitas solusi. Kami mempertahankan dokumentasi rinci dari semua interaksi dukungan untuk membangun pengetahuan dan meningkatkan layanan di masa depan.",
  
  // Resources section
  resourcesTitle: "Sumber Daya Teknis:",
  resourcesDescription: "Selain dukungan langsung, kami menyediakan dokumentasi teknis komprehensif, panduan instalasi, prosedur pemeliharaan, dan manual pemecahan masalah. Sumber daya digital kami mencakup spesifikasi produk rinci, grafik kompatibilitas, dan pedoman praktik terbaik untuk membantu pelanggan kami mencapai kinerja optimal dari produk kami.",
  
  // CTA button
  contactSupport: "Hubungi Dukungan Teknis",
  
  // Related services section
  relatedServicesTitle: "Layanan Terkait",
  relatedServicesDescription: "Jelajahi layanan komprehensif lainnya",
  afterSalesServiceDesc: "Dukungan purnajual komprehensif untuk memastikan kepuasan pelanggan.",
  customManufacturingDesc: "Solusi manufaktur yang disesuaikan untuk memenuhi persyaratan pelanggan spesifik.",
  qualityAssuranceDesc: "Proses kontrol kualitas ketat memastikan kepatuhan standar internasional.",
  readMore: "Baca selengkapnya"
};